module.exports = __webpack_public_path__ + "static/media/green_marker.6cb5ee87.png";